import CryptoJS from "crypto-js";

const hash = (str) => {
    return CryptoJS.SHA512(str).toString(CryptoJS.enc.Base64);
};

export default {
    hash,
};
